// src/components/Layout/Layout.jsx
import React from "react";
import Header from "../Header/Header";
import Footer from "../Footer/Footer";
import "./Layout.css";

const Layout = ({ children, fullBleed = false }) => {
  return (
    <div className="layout-wrapper">
      <Header />
      <main className={`layout-content ${fullBleed ? "layout-full-bleed" : ""}`}>{children}</main>
      <Footer />
    </div>
  );
};

export default Layout;
